module.exports = __webpack_public_path__ + "static/media/logo-branca.e1a22720.svg";